import React from 'react';

import loadHome from 'bundle-loader?lazy&title=Home!./components/routes/home';
import loadCompanyErrorPage from 'bundle-loader?lazy&title=CompanyErrorPage!./components/routes/company-error/company-error.jsx';
import loadProjectList from 'bundle-loader?lazy&title=ProjectList!./components/routes/projectList';
import loadProject from 'bundle-loader?lazy&title=NewProject!./components/routes/project';
import loadExportContent from 'bundle-loader?lazy&title=Import!./components/routes/export-content';
import loadImportContent from 'bundle-loader?lazy&title=Import!./components/routes/import-content';

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [ {
    title: 'Project',
    pattern: '/:companyId/project/:projectName',
    load: loadProject
}, {
    title: 'Export Content',
    pattern: '/:companyId/export-content',
    load: loadExportContent
}, {
    title: 'Import Content',
    pattern: '/:companyId/import-content',
    load: loadImportContent
}, {
    title: 'ProjectList',
    pattern: '/:companyId/projects',
    load: loadProjectList
}, {
    title: 'CMX Studio',
    pattern: '/:companyId',
    load: loadHome
}, {
    title: 'CMX Studio',
    pattern: '/',
    load: loadCompanyErrorPage
} ];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}

